import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAppStore = create(persist(
  (set) => ({
    nightMode: false,
    onboarded: false,
    healthPermissionAsked: false,
    calendarPermissionAsked: false,
    // One-shot flag for the 30-day health history backfill. Purely an
    // optimisation — the backfill itself skips dates the server already has,
    // so a lost flag (reinstall, account switch) just costs one cheap re-scan.
    healthBackfillDone: false,
    // Voice chat (Pro): push-to-talk mic input + spoken replies on the Chat
    // page. Off by default — speaking out loud is an explicit choice.
    voiceChatEnabled: false,
    toggleNightMode: () => set((s) => ({ nightMode: !s.nightMode })),
    setNightMode: (value) => set({ nightMode: value }),
    setOnboarded: (value) => set({ onboarded: value }),
    setHealthPermissionAsked: (value) => set({ healthPermissionAsked: value }),
    setCalendarPermissionAsked: (value) => set({ calendarPermissionAsked: value }),
    setHealthBackfillDone: (value) => set({ healthBackfillDone: value }),
    setVoiceChatEnabled: (value) => set({ voiceChatEnabled: value }),
  }),
  {
    name: 'cadence-app',
    partialize: (state) => ({
      nightMode: state.nightMode,
      onboarded: state.onboarded,
      healthPermissionAsked: state.healthPermissionAsked,
      calendarPermissionAsked: state.calendarPermissionAsked,
      healthBackfillDone: state.healthBackfillDone,
      voiceChatEnabled: state.voiceChatEnabled,
    }),
  }
));

export default useAppStore;
